import React, { useState } from 'react';

const sliderContent = [
    {
        id: '1',
        image: '/assets/images/onboarding_welcome_1780970846824.png',
        title: 'Selamat Datang di si-kembang',
        text: 'Aplikasi Sistem Informasi Kesehatan Tumbuh Kembang untuk memantau dan mendukung setiap langkah berharga si kecil.',
    },
    {
        id: '2',
        image: '/assets/images/onboarding_growth_1780970858806.png',
        title: 'Pantau Perkembangan dengan Mudah',
        text: 'Lakukan skrining perkembangan (KPSP), deteksi dini, dan pantau status gizi anak Anda sesuai standar WHO.',
    },
    {
        id: '3',
        image: '/assets/images/onboarding_education_1780970870977.png',
        title: 'Dapatkan Wawasan & Stimulasi',
        text: 'Akses artikel edukasi terpercaya dan dapatkan rekomendasi aktivitas stimulasi yang dipersonalisasi untuk anak Anda.',
    },
    {
        id: '4',
        image: '/assets/images/onboarding_start_1780970883950.png',
        title: 'Siap Memulai Perjalanan Hebat Ini?',
        text: 'Mari ciptakan awal terbaik untuk tumbuh kembang optimal anak Anda bersama si-kembang.',
    }
];

export default function OnboardingScreen({ navigate }) {
    const [currentIndex, setCurrentIndex] = useState(0);

    const handleNext = () => {
        if (currentIndex < sliderContent.length - 1) {
            setCurrentIndex(currentIndex + 1);
        }
    };

    const currentSlide = sliderContent[currentIndex];

    return (
        <div className="min-h-screen flex flex-col bg-gradient-to-br from-indigo-50 via-purple-50 to-pink-50 relative overflow-hidden">
            {/* Background decorative elements */}
            <div className="absolute top-0 left-0 w-full h-1/2 bg-gradient-to-b from-white/60 to-transparent rounded-b-[100px] pointer-events-none"></div>
            <div className="absolute -top-20 -right-20 w-64 h-64 bg-pink-200 rounded-full  blur-3xl opacity-50 "></div>
            <div className="absolute top-40 -left-20 w-72 h-72 bg-purple-200 rounded-full  blur-3xl opacity-50  "></div>
            <div className="absolute -bottom-8 left-20 w-72 h-72 bg-sky-200 rounded-full  blur-3xl opacity-50  "></div>

            <div className="flex-grow flex flex-col items-center justify-center p-8 text-center relative z-10">
                <div key={currentSlide.id} className="animate-fade-in-up flex flex-col items-center">
                    <div className="w-64 h-64 sm:w-80 sm:h-80 mb-8 rounded-3xl overflow-hidden shadow-2xl border-4 border-white transform transition-transform hover:scale-105">
                        <img 
                            src={currentSlide.image} 
                            alt={currentSlide.title} 
                            className="w-full h-full object-cover"
                        />
                    </div>
                    <h2 className="text-2xl sm:text-3xl font-extrabold text-brand-dark mb-4 drop-shadow-sm">{currentSlide.title}</h2>
                    <p className="text-brand-muted max-w-xs sm:max-w-md mx-auto text-sm sm:text-base leading-relaxed min-h-[84px]">
                        {currentSlide.text}
                    </p>
                </div>
            </div>
            
            <div className="p-8 bg-white/80 backdrop-blur-xl rounded-t-[40px] shadow-[0_-10px_40px_-15px_rgba(0,0,0,0.1)] relative z-10 border-t border-white/50">
                <div className="flex items-center justify-center space-x-3 mb-10">
                    {sliderContent.map((_, index) => (
                        <div
                            key={index}
                            className={`h-2.5 rounded-full transition-all duration-500 ease-in-out ${currentIndex === index ? 'bg-gradient-to-r from-purple-500 to-pink-500 w-10 shadow-md' : 'bg-gray-200 w-2.5'}`}
                        />
                    ))}
                </div>

                {currentIndex < sliderContent.length - 1 ? (
                    <div className="flex justify-between items-center px-2">
                        <button 
                            onClick={() => navigate('auth')} 
                            className="text-sm font-bold text-gray-400 hover:text-gray-600 px-4 py-2 transition-colors"
                        >
                            Lewati
                        </button>
                        <button 
                            onClick={handleNext} 
                            className="bg-gradient-to-r from-sky-500 to-blue-600 text-white font-bold py-3.5 px-8 rounded-2xl shadow-lg shadow-blue-500/30 hover:shadow-blue-500/50 hover:-translate-y-0.5 transition-all active:translate-y-0"
                        >
                            Lanjut
                        </button>
                    </div>
                ) : (
                    <button 
                        onClick={() => navigate('auth')}
                        className="w-full bg-gradient-to-r from-purple-600 to-pink-600 text-white font-bold py-4 px-4 rounded-2xl shadow-xl shadow-purple-500/30 hover:shadow-purple-500/50 hover:-translate-y-1 transition-all transform active:scale-95 focus:outline-none focus:ring-4 focus:ring-purple-500 focus:ring-opacity-50 text-lg"
                    >
                        Mulai Sekarang &rarr;
                    </button>
                )}
            </div>

            <style>{`
                @keyframes fade-in-up {
                    0% { opacity: 0; transform: translateY(20px); }
                    100% { opacity: 1; transform: translateY(0); }
                }
                .animate-fade-in-up {
                    animation: fade-in-up 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards;
                }
                
                    33% { transform: translate(30px, -50px) scale(1.1); }
                    66% { transform: translate(-20px, 20px) scale(0.9); }
                    100% { transform: translate(0px, 0px) scale(1); }
                }
                . {
                    animation: blob 7s infinite;
                }
                . {
                    animation-delay: 2s;
                }
                . {
                    animation-delay: 4s;
                }
            `}</style>
        </div>
    );
}
